import {createEvent} from "./createEvent";

export const basketEvents = {
    added: createEvent(),
    updated: createEvent(), // Данные в корзине изменены
};
